var map = {
	"./onboarding/welcome.svg": [
		"./src/assets/emeraldraws/onboarding/welcome.svg?inline",
		"draws/draw-onboarding-welcome-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/assets/emeraldraws lazy recursive ^\\.\\/.*\\.svg$";
module.exports = webpackAsyncContext;